import { Form } from 'antd';
import { delay } from 'lodash';
import { useState } from 'react';
import { cashierCtrl } from '../../cashier.controller';
import { IUIQuickPayChoose, IUISelectItem } from '../../cashier.interface';
import CashierActionButton, { ActionType } from '../../components/CashierActionButton';
import { useDollarAmountInputRef } from '../../components/DollarAmount/Input';
import HeaderActionButton, { HeaderActionButtonType } from '../../HeaderActions/HeaderActionButton';
import ModalAddPrice from './ModalAddPrice';
type Props = {
  add: (item: IUISelectItem) => void;
  onIssueGiftCard?: () => void;
  header?: boolean;
};
const CashierAddPrice = ({ header, onIssueGiftCard = () => undefined }: Props) => {
  const [form] = Form.useForm();
  const [visible, setVisible] = useState(false);
  const inputRef = useDollarAmountInputRef();
  const handleOpen = () => {
    setVisible(true);
    form.resetFields();
    delay(() => {
      inputRef.current?.focus();
    }, 100);
  };
  const handleClose = () => {
    setVisible(false);
  };

  const handleAdd = (values: IUIQuickPayChoose) => {
    cashierCtrl.addQuickPayItem(values);
    handleClose();
  };

  const handleOpenIssueGiftCard = () => {
    onIssueGiftCard();
    handleClose();
  };

  return (
    <>
      {!header ?
        <CashierActionButton
          type={ActionType.ADD_PRICE}
          onClick={handleOpen}
        />
        :
        <HeaderActionButton
          type={HeaderActionButtonType.ADD_PRICE}
          onClick={handleOpen}
        />
      }
      <ModalAddPrice
        form={form}
        inputRef={inputRef}
        visible={visible}
        onClose={handleClose}
        onSubmit={handleAdd}
        onIssueGiftCard={handleOpenIssueGiftCard}
      />
    </>
  );
};

export default CashierAddPrice;